import { Injectable } from '@angular/core';

@Injectable()
export class UtilsService {
  constructor() { }

  isNullOrEmptyOrUndefined(value: any): boolean {
    return value === null || value === undefined || value === '' || value === 0;
  }

  isEmailValid(value: any): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegex.test(value);
  }
}
